import { IApplicationTrackingSystem } from '../../interfaces/applicationTrackingSystem/iApplicationTrackingSystem'
import { IApplicationCard } from '../../interfaces/applicationTrackingSystem/iApplicationCard'
import { IApplication } from '../../interfaces/applicationTrackingSystem/iApplication'
import { Application } from '../../classes/applicationTrackingSystem/application'

export class ApplicationTrackingSystem implements IApplicationTrackingSystem {
	applicationsExist: boolean = false;
	isAdmin: boolean = true;
	applications: IApplicationCard[] = [];
	currentApplication: IApplication = new Application();
	totalClosed : number = 0;
	totalOpen : number = 0;
	totalQueue : number = 0;

	//constructor(memberProfile: IMemberProfile = {} as IMemberProfile) {
	//	this.generalInfo = memberProfile.generalInfo;
	//	this.locations = memberProfile.locations;
	//       this.causes = memberProfile.causes;
	//       this.companies = memberProfile.companies;
	//       this.network = memberProfile.network;
	//       this.schools = memberProfile.schools;
	//       this.philanthropy = memberProfile.philanthropy;
	//       this.currentPositions = memberProfile.currentPositions;
	//       this.fandoms = memberProfile.fandoms;
	//}
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/applicationTrackingSystem/applicationTrackingSystem.ts